import React, { useState, useContext } from "react";
import { useQuery } from "@apollo/react-hooks";

import config from "../../dashboard-config";

import TimeseriesMobile from "../Graphs/TimeseriesMobile";
import { ChartDataContext } from "../../context/ChartDataContext";
import { GET_BEST_TIME_SLICE_VALUES } from "../GraphQL/GetTimeSliceValues";

const graphStore = {
  wave: {
    name: "Significant Wave Height",
    tooltipName: "Significant Wave Height",
    graph: ["significantWaveHeight"],
    modelData: [
      {
        variableId: 20
      }
    ]
  },
  period: {
    name: "Peak Period, Mean Period",
    tooltipName: ["Peak Period", "Mean Period"],
    graph: ["peakPeriod", "meanPeriod"],
    modelData: [
      {
        variableId: 0
      },
      {
        variableId: 12
      }
    ]
  },
  direction: {
    name: "Peak Direction, Mean Direction",
    tooltipName: ["Peak Direction", "Mean Direction"],
    graph: ["peakDirection", "meanDirection"],
    modelData: [
      {
        variableId: 32
      },
      {
        variableId: 7
      }
    ]
  },
  spread: {
    name: "Peak Spread, Mean Spread",
    tooltipName: ["Peak Spread", "Mean Spread"],
    graph: ["peakDirectionalSpread", "meanDirectionalSpread"],
    modelData: [
      {
        variableId: 0
      },
      {
        variableId: 26
      }
    ]
  }
};

const DataCardGraphMobile = ({
  endDate,
  graphName,
  latitude,
  longitude,
  observationData,
  pointData,
  selectedGraph,
  startDate
}) => {
  const [optimalPointwiseData, setOptimalPointwiseData] = useState(null);
  const { setQueriedData } = useContext(ChartDataContext);

  const current = graphStore[selectedGraph]["graph"];

  let queryLongitude = longitude,
    queryLatitude = latitude;
  const currentVariableId =
    selectedGraph === "wave"
      ? graphStore[selectedGraph].modelData[0].variableId
      : graphStore[selectedGraph].modelData[1].variableId;

  if (longitude < 0) queryLongitude += 360;

  if (pointData) {
    queryLatitude = pointData[1];
    queryLongitude = pointData[0] + 360;
  }

  useQuery(GET_BEST_TIME_SLICE_VALUES, {
    context: { clientName: "wexGeo" },
    fetchPolicy: "cache-first",
    variables: {
      input: {
        dataSourceId: 19,
        variableId: currentVariableId,
        start: startDate,
        end: endDate,
        location: { latitude: queryLatitude, longitude: queryLongitude }
      }
    },
    onError: e => console.error(`use query: ${e}`),
    onCompleted: data => {
      setOptimalPointwiseData(data.bestTimeSliceValues);
      setQueriedData(data.bestTimeSliceValues);
    }
  });

  return (
    <React.Fragment>
      {optimalPointwiseData && pointData ? (
        <TimeseriesMobile
          endDate={endDate}
          graphName={graphName}
          optimalPointwiseData={optimalPointwiseData}
          optimalPointwiseTimestampData={optimalPointwiseData.map(
            record => record.instant.split(["["])[0]
          )}
          selectedGraph={selectedGraph}
          selectedChart={current}
          startDate={startDate}
        />
      ) : (
        <React.Fragment>
          {optimalPointwiseData && (
            <TimeseriesMobile
              endDate={endDate}
              graphName={graphName}
              observationData={observationData.map(record => record.data)}
              observationTimestampData={observationData.map(
                record => record.timestamp
              )}
              optimalPointwiseData={optimalPointwiseData}
              optimalPointwiseTimestampData={optimalPointwiseData.map(
                record => record.instant.split(["["])[0]
              )}
              selectedGraph={selectedGraph}
              selectedChart={current}
              startDate={startDate}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default DataCardGraphMobile;
